import { ImageResponse } from "next/og";

export const runtime = "edge";
export const contentType = "image/png";
export const size = { width: 1200, height: 630 };
export const alt = "Tử Vi Số";

/**
 * Default OG image for the site root and any page that doesn't override.
 * Brand-consistent with the gold/red palette and Cormorant display feel.
 */
export default function OG() {
  return new ImageResponse(
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0c0a09",
        backgroundImage:
          "radial-gradient(ellipse at top, rgba(180, 145, 70, 0.18), transparent 60%), radial-gradient(ellipse at bottom, rgba(170, 50, 50, 0.12), transparent 65%)",
        color: "#f5f1e8",
        padding: 80,
        position: "relative",
      }}
    >
      {/* Ornament line */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          color: "#c8a35c",
          fontSize: 22,
          letterSpacing: 8,
          textTransform: "uppercase",
          marginBottom: 28,
        }}
      >
        <span style={{ width: 60, height: 1, background: "#c8a35c" }} />
        Tử Vi · Phong Thủy · Mệnh Học
        <span style={{ width: 60, height: 1, background: "#c8a35c" }} />
      </div>

      <div
        style={{
          fontFamily: "serif",
          fontSize: 132,
          fontWeight: 600,
          lineHeight: 1,
          color: "#f5f1e8",
          textAlign: "center",
        }}
      >
        Tử Vi Số
      </div>

      <div
        style={{
          marginTop: 28,
          fontSize: 32,
          color: "#b8a989",
          textAlign: "center",
          maxWidth: 900,
          lineHeight: 1.4,
        }}
      >
        Khám phá vận mệnh, lá số tử vi, vận năm và phong thủy
      </div>

      {/* Bottom corner mark */}
      <div
        style={{
          position: "absolute",
          bottom: 60,
          display: "flex",
          alignItems: "center",
          gap: 12,
          color: "#c8a35c",
          fontSize: 22,
          letterSpacing: 4,
          textTransform: "uppercase",
        }}
      >
        tuviso.vn
      </div>
    </div>,
    { ...size }
  );
}
